import Http from 'components/http/Http';
import React from 'react';


class Logout extends React.Component {
  constructor() {
    super();
    this.http = new Http.Factory().create();
    this.state = { loaded: false, content: '' };
  }

  async _get() {
    try {
      await this.http.get('/goodbye');
    } catch(error) {
      this.setState({ loaded: true, content: 'Could not reach server.' });
      return;
    }
    this.setState({ loaded: true, content: 'You have been logged out.' });
  };

  render() {

    if (!this.state.loaded) {
      this._get();
    }

    return (
      <div className='logout'>{this.state.content}</div>
    );
  }
}


export default Logout;

